import axios from 'axios'

class ConfigService {
  static postConfiguration (configuration) {
    return axios.post('api/configuration', configuration)
  }
};

export default ConfigService
